import { Entity } from '@/store/shared/entity'
export default class Logistics extends Entity<number>{
    name:string;
    remark:string;
    isTrailer:Boolean = undefined;
}